@if (data) {
	<a (click)="data.callback()">
		@if (data.icon) {
			<app-icon [name]="data.icon" color="primary-1" size="small"></app-icon>
		}
		@if (data.title) {
			<span>{{ data.title }}</span>
		}
	</a>
}
